export enum NativeResponseType {
  OIDC_CLEAR = 'OIDC_CLEAR',
  DOWNLOAD_BLOB = 'DOWNLOAD_BLOB',
  OIDC_USER = 'OIDC_USER_FROM_SPA',
}

export enum NativeResponseSource {
  LOGIN_STATUS = 'loginStatus',
}
